import {css} from "styled-components";

export const mobile = (props) => {
    return css`
    @media only screen and (max-width: 391px){
        ${props}
    }
    `
}
export const tab = (props) => {
    return css`
    @media (max-width:768px){
        ${props}
    }
    `
}